import Spinner from "@/components/atoms/Spinner/Spinner";
import SbcSolutionPage from "@/pages/Sbcs/SbcSolutionPage";
import StreamlineSbcPage from "@/pages/Sbcs/StreamlineSbcPage/StreamlineSbcPage";
import { getSbcSetSelector, getSbcsSelector } from "@/redux/sbcs/sbcsSlice";
import { useSelector } from "react-redux";
import { useParams } from "react-router";

// Both set kinds share the challenge URL, so the set's kind picks the page.
// Both solve on mount, so neither renders before the kind is known.
const SbcChallengePage = () => {
  const { setId } = useParams();
  const sbcSet = useSelector(getSbcSetSelector(Number(setId)));
  const { sbcSetStatus } = useSelector(getSbcsSelector);
  // The selector falls back to the last fetched set, whatever its id.
  const known = sbcSet?.id === Number(setId);

  if (known && sbcSet.kind === "STREAMLINE")
    return <StreamlineSbcPage sbcSet={sbcSet} />;
  // An expired set no longer loads; its challenge solves as it always has.
  if (known || sbcSetStatus === "rejected") return <SbcSolutionPage />;
  return (
    <main className="flex min-h-screen justify-center pt-24">
      <Spinner />
    </main>
  );
};

export default SbcChallengePage;
